import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import cogoToast from "cogo-toast";
import Input from "components/Input/Input";
import { BACKEND_URL } from "../../../constants";
import ButtonPrimary from "components/Button/ButtonPrimary";
import Heading2 from "components/Heading/Heading2";
import ClipLoader from "react-spinners/ClipLoader";
import 'moment/locale/pl';
import "react-datetime/css/react-datetime.css";
import Layout from "../layout";

const PageAddYoutubeVideos = () => {
  const [loading,setLoading] = useState(false)
  const [youtube, setYoutube] = useState("")
  let user = sessionStorage.getItem("user")
  const initialized = useRef(false);

  const addYoutubeVideo = async (e) => {
    e.preventDefault();
    setLoading(true)
    setTimeout(() => {
      fetch(`${BACKEND_URL}/add_youtube_videos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          youtube_id: youtube
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.statusCode === 200) {
            cogoToast.success("Film Youtube został dodany");
            setLoading(false)
            window.location.reload()
          } 
        })
        .catch((error) => console.error("error: ", error));
    }, [2000]);
  };
  return (
    <Layout>
      <header className="text-center max-w-2xl mx-auto - mb-14 sm:mb-16 lg:mb-20 ">
        <Heading2>Dodaj Youtube Wideo</Heading2>
      </header>

      <div className="max-w-md mx-auto space-y-6">
        {/* FORM */}
        <form className="grid grid-cols-1 gap-6" action="#" method="post">
          <label className="block">
            <Input
              onChange={(e) => setYoutube(e.target.value)}
              type="text"
              placeholder="Wpisz nowe youtube id"
              className="mt-1"
            />
          </label>
        </form>
        <ButtonPrimary onClick={addYoutubeVideo}>Dodaj</ButtonPrimary>
        {loading === true && 
        <div style={{marginTop:'40px'}}>
          <ClipLoader color="black" size={50} aria-label="Loading Spinner" data-testid="loader"/>
          </div>}
      </div>
    </Layout>
  );
};

export default PageAddYoutubeVideos;